// Module
var code = "<template> <ess-card class=\"ess-col s12\" if.bind=\"noteCategory\"> <div class=\"card-title\">${'um:auth.additionalInfo.$long' | t}</div> <div> <ess-textarea value.bind=\"additionalInfoText\" label.bind=\"additionalInfoLabel\" maxlength=\"2000\"></ess-textarea> </div> </ess-card> </template> ";
// Exports
module.exports = code;